import { TTimeSlot, TTimeSlotListItem } from '../../type'

// приведение данных о таймслоте к нужному виду

export const initValiableTimeSlots = (
  timeSlotsListValue: TTimeSlotListItem[],
  appealTimeSlotValue: TTimeSlot[],
): TTimeSlotListItem[] => {
  appealTimeSlotValue.forEach(slot => {
    if (!timeSlotsListValue.find(item => item.id === slot.id)) {
      const from = slot.dateFrom.slice(11, 16) // Извлечение часов и минут из dateFrom
      const to = slot.dateTo.slice(11, 16) // Извлечение часов и минут из dateTo
      if (slot.id)
        // eslint-disable-next-line no-param-reassign
        timeSlotsListValue = [
          ...timeSlotsListValue,
          { id: slot.id, from, to, disabled: true },
        ]
    }
  })
  return timeSlotsListValue
}
